<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {{ $t("workflows.new_workflow_modal.title") }}</DialogTitle
                >
            </DialogHeader>

            <div class="mt-2">
                <div class="mt-4">
                    <label
                        for="workflow-name"
                        class="block text-sm font-medium text-iron-700"
                        >{{
                            $t("workflows.new_workflow_modal.nameLabel")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <input
                            v-model="workflowName"
                            type="text"
                            data-cy="new-workflow-name"
                            name="workflow-name"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                            :placeholder="
                                $t(
                                    'workflows.new_workflow_modal.name_placeholder',
                                )
                            "
                        />
                    </div>
                </div>

                <div class="mt-4">
                    <label
                        for="trigger"
                        class="block text-sm font-medium text-iron-700"
                        >{{ $t("workflows.new_workflow_modal.trigger") }}</label
                    >
                    <div class="mt-1 w-full">
                        <select
                            v-model="trigger"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                        >
                            <option :value="null">
                                {{
                                    $t(
                                        "workflows.new_workflow_modal.trigger_placeholder",
                                    )
                                }}
                            </option>
                            <option
                                v-for="(triggerType, i) in triggerTypes"
                                :key="i"
                                :value="triggerType.value"
                            >
                                {{ triggerType.label }}
                            </option>
                        </select>
                    </div>
                </div>

                <div
                    v-if="trigger === 'reservation_will_happen_in'"
                    class="mt-4"
                >
                    <label
                        for="email"
                        class="block text-sm font-medium text-iron-700"
                        >{{
                            $t("workflows.new_workflow_modal.time_before")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <select
                            v-model="timeBefore"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                        >
                            <option :value="3600">
                                {{ $t("workflows.new_workflow_modal.hour") }}
                            </option>

                            <option :value="7200">
                                {{
                                    $t("workflows.new_workflow_modal.two_hours")
                                }}
                            </option>

                            <option :value="86400">
                                {{ $t("workflows.new_workflow_modal.day") }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="mt-4">
                    <label
                        for="action"
                        class="block text-sm font-medium text-iron-700"
                    >
                        {{ $t("workflows.new_workflow_modal.action") }}</label
                    >
                    <div class="mt-1 w-full">
                        <select
                            v-model="action"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                        >
                            <option :value="null">
                                {{
                                    $t(
                                        "workflows.new_workflow_modal.action_placeholder",
                                    )
                                }}
                            </option>
                            <option
                                v-for="(actionType, i) in activeActionTypes"
                                :key="i"
                                :value="actionType.value"
                            >
                                {{ actionType.label }}
                            </option>
                        </select>
                    </div>
                </div>

                <div v-if="action === 'add_contact_to_ecomail'" class="mt-4">
                    <label
                        for="workflow-name"
                        class="block text-sm font-medium text-iron-700"
                        >{{
                            $t("workflows.new_workflow_modal.contact_list_id")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <input
                            v-model="contactListId"
                            type="number"
                            data-cy="new-workflow-contact-list-id"
                            name="workflow-contact-list-id"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                            :placeholder="
                                $t(
                                    'workflows.new_workflow_modal.contact_list_id_placeholder',
                                )
                            "
                        />
                    </div>
                </div>

                <div v-if="action === 'add_task_to_freelo'" class="mt-4">
                    <label
                        for="workflow-name"
                        class="block text-sm font-medium text-iron-700"
                        >{{
                            $t("workflows.new_workflow_modal.project_id")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <select
                            v-model="projectId"
                            data-cy="new-workflow-project-id"
                            name="project-id"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                        >
                            <option disabled :value="null">
                                {{ projectSelectTextation }}
                            </option>
                            <option
                                v-for="freeloProject in freeloProjects"
                                :value="freeloProject.id"
                                :key="freeloProject.id"
                            >
                                {{ freeloProject.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div v-if="action === 'add_task_to_freelo'" class="mt-4">
                    <label
                        for="workflow-name"
                        class="block text-sm font-medium text-iron-700"
                        >{{
                            $t("workflows.new_workflow_modal.tasklist_id")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <select
                            v-model="tasklistId"
                            data-cy="new-workflow-tasklist-id"
                            name="tasklist-id"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                        >
                            <option disabled :value="null">
                                {{ tasklistSelectTextation }}
                            </option>
                            <option
                                v-for="freeloTasklist in freeloTasklists"
                                :value="freeloTasklist.id"
                                :key="freeloTasklist.id"
                            >
                                {{ freeloTasklist.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div v-if="action === 'add_task_to_freelo'" class="mt-4">
                    <label
                        for="workflow-name"
                        class="block text-sm font-medium text-iron-700"
                        >{{
                            $t("workflows.new_workflow_modal.worker_id") +
                            " (" +
                            $t("optional") +
                            ")"
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <select
                            v-model="workerId"
                            data-cy="new-workflow-worker-id"
                            name="worker-id"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                        >
                            <option disabled :value="null">
                                {{ workerSelectTextation }}
                            </option>
                            <option
                                v-for="freeloWorker in freeloWorkers"
                                :value="freeloWorker.id"
                                :key="freeloWorker.id"
                            >
                                {{ freeloWorker.fullname }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="mt-4">
                    <label
                        for="target"
                        class="block text-sm font-medium text-iron-700"
                    >
                        {{ $t("workflows.new_workflow_modal.target") }}</label
                    >
                    <div class="mt-1 w-full">
                        <select
                            v-model="target"
                            class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                        >
                            <option :value="null">
                                {{
                                    $t(
                                        "workflows.new_workflow_modal.target_placeholder",
                                    )
                                }}
                            </option>
                            <option
                                v-for="(targetType, i) in activeTargetTypes"
                                :key="i"
                                :value="targetType.value"
                            >
                                {{ targetType.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="closeModal"
                >
                    {{ $t("cancel") }}
                </button>

                <ZButton class="ml-4" type="button" @click="createWorkflow">{{
                    $t("workflows.new_workflow")
                }}</ZButton>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import ZButton from "../../Atomic/Button.vue";
import { computed, ref, watch } from "vue";
import { router } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import route from "ziggy-js";
import axios from "axios";
const { t } = useI18n();

const props = defineProps({
    integrations: {
        type: Array,
        requiored: true,
    },
});

const opened = ref(false);

const workflowName = ref("" as string);
const contactListId = ref<number>();

const triggerTypes = [
    {
        label: t("workflows.triggers.reservation_made"),
        value: "reservation_made",
    },
    {
        label: t("workflows.triggers.reservation_canceled"),
        value: "reservation_canceled",
    },
    {
        label: t("workflows.triggers.reservation_prepared"),
        value: "reservation_prepared",
    },
    {
        label: t("workflows.triggers.reservation_will_happen_in"),
        value: "reservation_will_happen_in",
    },
];

const actionTypes = [
    {
        label: t("workflows.actions.send_email"),
        value: "send_email",
    },
];

resolveAvailableActionTypes(props.integrations);

function resolveAvailableActionTypes(integrations: any) {
    const integrationTypes = integrations.map(
        (integration: any) => integration.type,
    );

    if (integrationTypes.includes("ECOMAIL")) {
        actionTypes.push({
            label: t("workflows.actions.add_contact_to_ecomail"),
            value: "add_contact_to_ecomail",
        });
    }

    if (integrationTypes.includes("CLOSE")) {
        actionTypes.push({
            label: t("workflows.actions.add_lead_to_close"),
            value: "add_lead_to_close",
        });
    }

    if (integrationTypes.includes("SLACK")) {
        actionTypes.push({
            label: t("workflows.actions.send_to_slack"),
            value: "send_to_slack",
        });
    }

    if (integrationTypes.includes("RAYNET")) {
        actionTypes.push({
            label: t("workflows.actions.add_lead_to_raynet"),
            value: "add_lead_to_raynet",
        });
    }

    if (integrationTypes.includes("FREELO")) {
        actionTypes.push({
            label: t("workflows.actions.add_task_to_freelo"),
            value: "add_task_to_freelo",
        });
    }
}

const freeloIntegration = computed(() => {
    if (!props.integrations) {
        return null;
    }

    return props.integrations.find(
        (integration: any) => integration.type === "FREELO",
    );
});

const targetTypes = [
    {
        label: t("workflows.targets.attendees"),
        value: "attendees",
    },
    {
        label: t("workflows.targets.host"),
        value: "host",
    },
];

const trigger = ref(null as string | null);
const action = ref(null as string | null);
const target = ref(null as "host" | "attendees" | null);
const timeBefore = ref(3600);

const projectId = ref(null as number | null);
const tasklistId = ref(null as number | null);
const workerId = ref(null as number | null);

const activeActionTypes = computed(() => {
    if (
        trigger.value !== "reservation_made" &&
        trigger.value !== "reservation_prepared"
    ) {
        return actionTypes.filter(
            (actionType) =>
                actionType.value !== "add_contact_to_ecomail" &&
                actionType.value !== "add_lead_to_close" &&
                actionType.value !== "add_lead_to_raynet" &&
                actionType.value !== "add_task_to_freelo",
        );
    }

    return actionTypes;
});

const activeTargetTypes = computed(() => {
    if (
        action.value === "add_contact_to_ecomail" ||
        action.value === "add_lead_to_close" ||
        action.value === "send_to_slack" ||
        action.value === "add_lead_to_raynet" ||
        action.value === "add_task_to_freelo"
    ) {
        return targetTypes.filter(
            (targetType) => targetType.value !== "attendees",
        );
    }

    return targetTypes;
});

watch(action, (newValue) => {
    if (newValue === "add_task_to_freelo") {
        getFreeloProjects();
    }
});

watch(projectId, (newValue) => {
    if (newValue) {
        getFreeloTasklists();
        tasklistId.value = null;
        workerId.value = null;
    }
});

watch(tasklistId, (newValue) => {
    if (newValue) {
        getFreeloWorkers();
        workerId.value = null;
    }
});

const projectSelectTextation = computed(() => {
    return loadingFreeloProjects.value
        ? t("workflows.freelo.projects_loading")
        : t("workflows.freelo.select_project");
});

const tasklistSelectTextation = computed(() => {
    if (projectId.value === null) {
        return t("workflows.freelo.select_project_first");
    }

    return loadingFreeloTasklists.value
        ? t("workflows.freelo.tasklists_loading")
        : t("workflows.freelo.select_tasklist");
});

const workerSelectTextation = computed(() => {
    if (tasklistId.value === null) {
        return t("workflows.freelo.select_tasklist_first");
    }

    return loadingFreeloWorkers.value
        ? t("workflows.freelo.workers_loading")
        : t("workflows.freelo.select_worker");
});

const createWorkflow = function () {
    router.post(
        route("app.workflows.store"),
        {
            name: workflowName.value,
            trigger: trigger.value,
            action: action.value,
            target: target.value,
            timeBefore:
                trigger.value === "reservation_will_happen_in"
                    ? timeBefore.value
                    : null,
            contactListId: contactListId.value,
            projectId: projectId.value,
            tasklistId: tasklistId.value,
            workerId: workerId.value,
        },
        {
            onFinish: () => {
                trigger.value = null;
                action.value = null;
                target.value = null;
                timeBefore.value = 3600;
                closeModal();
            },
        },
    );
};

const closeModal = () => {
    opened.value = false;
};

const freeloProjects = ref([]);
const loadingFreeloProjects = ref(true);

async function getFreeloProjects() {
    if (freeloIntegration.value === null) {
        return;
    }

    try {
        const response = await axios.get(
            route("app.freelo-integrations.projects", {
                integration: freeloIntegration.value.id,
            }),
        );
        if (response.data.success) {
            freeloProjects.value = response.data.data;
            loadingFreeloProjects.value = false;
        }
    } catch (error) {}
}

const freeloTasklists = ref([]);
const loadingFreeloTasklists = ref(true);
async function getFreeloTasklists() {
    if (freeloIntegration.value === null) {
        return;
    }

    try {
        const response = await axios.get(
            route("app.freelo-integrations.tasklists", {
                integration: freeloIntegration.value.id,
                project: projectId.value,
            }),
        );
        if (response.data.success) {
            freeloTasklists.value = response.data.data;
            loadingFreeloTasklists.value = false;
        }
    } catch (error) {}
}

const freeloWorkers = ref([]);
const loadingFreeloWorkers = ref(true);

async function getFreeloWorkers() {
    if (freeloIntegration.value === null) {
        return;
    }

    try {
        const response = await axios.get(
            route("app.freelo-integrations.users", {
                integration: freeloIntegration.value.id,
                project: projectId.value,
                tasklist: tasklistId.value,
            }),
        );
        if (response.data.success) {
            freeloWorkers.value = response.data.data;
            loadingFreeloWorkers.value = false;
        }
    } catch (error) {
        console.log(error);
    }
}
</script>

<style></style>
